import { html } from 'lit';
import { showToast } from '../../../modules/ShowShoelaceToast.js';
import { UnsupportedPhotoFormatError } from './PhotoUploadService.js';

const GENERIC_MESSAGE = 'Failed to upload photo. Please try again, and contact support if the problem continues.';
const UNSUPPORTED_FORMAT_MESSAGE = 'Only JPEG photos can be uploaded.';

/**
 * Shows an error toast when a photo fails to upload.
 * @param {unknown} [error]
 */
export function showPhotoUploadErrorToast(error) {
  const message = error instanceof UnsupportedPhotoFormatError ? UNSUPPORTED_FORMAT_MESSAGE : GENERIC_MESSAGE;

  showToast(
    {
      variant: 'danger',
      duration: 10_000,
      content: html`
        <katapult-icon slot="icon" icon="error"></katapult-icon>
        <div style="white-space: pre-line;">${message}</div>
      `
    },
    'bottom'
  );
}
